@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container">
      <tidy-text [header]="'Noise Monitoring'" />
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search Properties'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    </div>
    <div class="non-wrappable-right-aligned-container">
      <automations-preview-button
        [tag]="'noise-monitoring'" />
    </div>
  </tidy-desktop-header>
}

@if (!windowService.isDesktopRes) {
  @if (allRows.length) {
    <form [formGroup]="form" novalidate action="#" style="margin-bottom: 10px;">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search Properties'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
  }
}

<!-- First-load skeleton — mirrors the loaded layout exactly (promo card,
     Noise Levels chart card, table) so each section swaps in place. The
     skeletons float in with a staggered cascade; the real content below
     replaces them instantly (no animation, [skipEntrance] on the table). -->
@if (!loaded) {
  <tidy-card class="sk-section sk-promo-card">
    <div class="sk-promo-layout">
      <ion-skeleton-text [animated]="true" class="sk-promo-img" />
      <div class="sk-promo-body">
        <ion-skeleton-text [animated]="true" class="sk-promo-title" />
        <ion-skeleton-text [animated]="true" class="sk-promo-line" />
        <div class="sk-promo-links">
          <ion-skeleton-text [animated]="true" class="sk-promo-link" />
          <ion-skeleton-text [animated]="true" class="sk-promo-link" />
        </div>
      </div>
    </div>
  </tidy-card>

  <tidy-card class="sk-section sk-chart-card">
    <tidy-row>
      <ion-skeleton-text [animated]="true" class="sk-chart-title" />
    </tidy-row>
    <div class="sk-chart">
      <div class="sk-chart-body">
        <ion-skeleton-text [animated]="true" class="sk-chart-ytitle" />
        <div class="sk-chart-yaxis">
          @for (i of [1, 2, 3, 4, 5, 6]; track i) {
            <ion-skeleton-text [animated]="true" class="sk-yaxis-label" />
          }
        </div>
        <div class="sk-chart-plot">
          <ion-skeleton-text [animated]="true" class="sk-chart-line sk-chart-line-1" />
          <ion-skeleton-text [animated]="true" class="sk-chart-line sk-chart-line-2" />
          <ion-skeleton-text [animated]="true" class="sk-chart-line sk-chart-line-3" />
        </div>
      </div>
      <div class="sk-chart-xaxis">
        @for (i of [1, 2, 3, 4, 5, 6, 7]; track i) {
          <ion-skeleton-text [animated]="true" class="sk-xaxis-label" />
        }
      </div>
    </div>
  </tidy-card>

  <tidy-table
    class="noise-table-compact sk-table"
    [skeletonLoading]="true"
    [skeletonRowCount]="3"
    [scrollWithPage]="true"
    [columnslabels]="headers" />
}

@if (loaded) {
  <sensor-promo-card (orderClick)="openOrderSensor()" (learnMoreClick)="openHardwareInfo()" />

  <div [hidden]="showAboutThisPage && !windowService.isDesktopRes">
    @if (!searchTerm) {
      <tidy-card #noiseLevelsCard>
        <tidy-row>
          <tidy-text [header]="'Noise Levels'" />
        </tidy-row>
        <tidy-lazy-chart
          [series]="chartSeries"
          [chart]="chartOptions"
          [xaxis]="chartXaxis"
          [yaxis]="chartYaxis"
          [stroke]="chartStroke"
          [grid]="chartGrid"
          [tooltip]="chartTooltip"
          style="margin-top: 12px; display: block;" />
      </tidy-card>
    }

    <tidy-table
      #tidyTable
      class="noise-table-compact"
      [dataSource]="shownRows"
      [displayedColumns]="headers"
      [columnslabels]="headers"
      [showColumnLines]="false"
      [rowsToShow]="50"
      [allRowIsClickable]="true"
      (cellClick)="onTableColumnClick($event)"
      [skipEntrance]="true"
      [blockSorting]="true"
      [scrollWithPage]="true"
      [enableVirtualScrolling]="false" />
  </div>
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'noise-monitoring'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
